import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'src/app/common/button/button.module';
import { SwiperConfigInterface, SwiperModule } from 'ngx-swiper-wrapper';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { EventsService, UtilService, VariablesService } from 'src/app/shared/services';
import { HealthFirstService } from '../../services/health-first.service';
@Component({
  selector: 'app-hf-plan-details-mob',
  standalone: true,
  imports: [
    CommonModule,
    ButtonModule,
    SwiperModule,
    MatIconModule,
    MatButtonModule
  ],
  templateUrl: './hf-plan-details-mob.component.html',
  styleUrls: ['./hf-plan-details-mob.component.scss']
})
export class HfPlanDetailsMobComponent implements OnInit {
  @Input() plans;
  @Input() showSlider = false;
  @Input() recommended = '';
  @Input() info_3 = '';
  @Input() amountData;
  info = [
    {id: 1, desc: 'Enjoy greater savings on medication, lab tests and consultations'},
    {id: 2, desc: 'All core benefits of HealthFirst Essentials plus surgery care & daily hospital cash'}
  ]
  hide = true;
  
  config: SwiperConfigInterface = {
    direction: 'horizontal',
    slidesPerView: 'auto',
    initialSlide: 1,
    navigation: true,
    keyboard: true,
    scrollbar: false,
    loop: true,
    observer: true,
    preloadImages: false,
    spaceBetween: 16,
    centeredSlides: false,
    pagination: false,
    breakpoints: {
      992: {
        slidesPerView: 'auto',
        centeredSlides: false,
        allowTouchMove: true,
        loop: false,
        initialSlide: 0,
        observer: true,
      },
      768: {
        slidesPerView: 1.2,
        centeredSlides: true,
        allowTouchMove: true,
        navigation: true,
        loop: false,
        initialSlide: 0,
        observer: true,
      }
    }
  };

  userData;

  constructor(
    public util: UtilService,
    public vars: VariablesService,
    private events: EventsService,
    private hfService: HealthFirstService
  ) {}

  ngOnInit(): void {
    this.vars.userData.subscribe({
      next: user => {
        if (user) {
          this.userData = user;
        }
      }
    });
    this.vars.pageName = 'chooseplan';
  }

  buyNow(selected) {
    const eventData = {
      page_name: 'chooseplan',
      eventName: 'buynow',
      info_1: this.util.stripHtml(selected.plan) + ' Plan',
      info_2: selected.amount,
    };
    eventData['info_3'] = this.hfService.selectedBenefit ? this.util.stripHtml(this.hfService.selectedBenefit.info_2) : this.info_3 ? this.util.stripHtml(this.info_3) : 'homepage';
    this.events.sendSystemEvent(eventData).subscribe(_ => _);
    this.events.claverTapPush('Healthfirst chooseplan', {
      'Event Name': 'buynow',
      'info_1': this.util.stripHtml(selected.plan) + ' Plan',
      'info_2': selected.amount
    });
    if (this.userData) {
      this.util.router.navigate(['/healthfirst/price-breakup'], { queryParams: { plan: selected.plan }, queryParamsHandling: 'merge' });
    } else {
      this.util.router.navigate(['/new/signin'], { queryParams: { redirect_uri: '/healthfirst/price-breakup', vendor: 'medibuddy', plan: selected.plan, logintype: 'findmyplan' }, queryParamsHandling: 'merge' });
    }
  }
}
